import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  useInrWithdrawMutation,
  useTransWithdModelCommissionDataQuery,
} from "../../redux/TransactionApi";
import { toast } from "react-toastify";

function INRWithdrawModal({ open, onClose, editData }) {
  const [amount, setAmount] = useState("");
  const [isSelfWallet, setIsSelfWallet] = useState(false);
  const [btnDisabled, setButtonDisabled] = useState(false);

  const [errors, setErrors] = useState({});

  const { data: commissionDetails } = useTransWithdModelCommissionDataQuery(
    { currency_id: editData?.currency_id },
    { skip: !open }
  );
  const [inrWithdraw, { isLoading: isSubmitting }] = useInrWithdrawMutation();

  const handleClose = () => {
    setAmount("");
    setErrors({});
    onClose();
    setIsSelfWallet(false)
  };

  const validate = () => {
    let newErrors = {};

    if (!amount) {
      newErrors.amount = "This field is required";
    } else if (isNaN(amount) || Number(amount) <= 0) {
      newErrors.amount = "Enter a valid number";
    } else if (
      commissionDetails?.data?.min_withdrawal &&
      Number(amount) < Number(commissionDetails?.data?.min_withdrawal)
    ) {
      newErrors.amount = `Minimum withdrawal is ${commissionDetails?.data?.min_withdrawal}`;
    } else if (
      editData?.wallet_balance &&
      Number(amount) > Number(editData?.wallet_balance)
    ) {
      newErrors.amount = "Insufficient balance";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRaiseRequest = async () => {
    if (!validate()) return;
    setButtonDisabled(true);
    setTimeout(() => setButtonDisabled(false), 3000);
    try {
      const payload = {
        amount: Number(amount),
        tds: isSelfWallet ? 1 : 0,
      };

      const { error, data } = await inrWithdraw(payload);
      toast.dismiss();
      if (error) {
        toast.error(error?.data?.message || "Failed to submit request");
      }
      if (data) {
        toast.success(data?.message);

        handleClose();
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Modal
        show={open}
        onHide={handleClose}
        className="account-popup-outer"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Withdrawal</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="wallet-balance form-group row">
            <div className="col-12 mb-3">
              <span className="mb-0 form-control d-flex">
                Wallet Balance:
                <b className="ml-auto">
                  {parseFloat(editData?.wallet_balance)?.toFixed(3)}
                </b>
              </span>
            </div>

            <div className="col-6">
              <span className="form-control d-flex">
                Min Withdrawal:{" "}
                <b className="ml-auto">
                  {parseFloat(commissionDetails?.data?.min_withdrawal)?.toFixed(
                    3
                  )}
                </b>
              </span>
            </div>

            <div className="col-6">
              <span className="form-control d-flex">
                Withdrawal Fees:
                <b className="ml-auto">
                  {parseFloat(
                    commissionDetails?.data?.withdrawal_commission
                  )?.toFixed(3)}{" "}
                  {commissionDetails?.data?.fees_type === "flat" ? "" : "%"}
                </b>
              </span>
            </div>
          </div>

          <div>
            <div className="form-group">
              <label className="mb-0">Coin</label>
              <div className="form-control">INR</div>
            </div>

            <div className="form-group">
              <label className="mb-0">Amount</label>
              <div className="relative">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={(e) => {
                    let val = e.target.value;

                    if (/^\d{0,7}(\.\d{0,2})?$/.test(val)) {
                      setAmount(val);
                      setErrors((prev) => ({ ...prev, amount: "" }));
                    }
                  }}
                />
                {/* <span className="absolute_btc">USDT</span> */}
              </div>
              {errors.amount && (
                <small className="text-danger">{errors.amount}</small>
              )}
            </div>
            <div className="form-group mb-0">
              <input
                type="checkbox"
                id="check1"
                checked={isSelfWallet}
                onChange={(e) => setIsSelfWallet(e.target.checked)}
              />
              <label htmlFor="check1" className="ml-2">
                Transfer to self wallet (Consent No TDS)
              </label>
            </div>

            <div className="tc mb-3">
              <button
                className="btn btn_man fs14"
                onClick={handleRaiseRequest}
                disabled={isSubmitting || btnDisabled}
              >
                Withdraw Amount
              </button>
            </div>
            <div>
              <div className="not_box">
                <h5>Note</h5>
                <h6 className="mb-0">Consent:</h6>
                <p className="mt-1">
                  If you haven't given consent, TDS will be deducted. No TDS
                  applies when transferring assets to your own wallet or another
                  exchange account.
                </p>
                <h6>TDS details:</h6>
                <ol>
                  <li>
                    Income Tax Section 194S mandates a {commissionDetails?.data?.tds??0}% TDS deduction on the
                    sale of Virtual Digital Assets by Indian residents.
                  </li>
                  <li>
                    Green Crypto deducts TDS on
                    behalf of the buyer.
                  </li>
                  <li>
                    TDS rate varies to 5%, subject to Section 206AB, or 20% if
                    Aadhar and PAN card are not linked.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default INRWithdrawModal;
